import { useMemo } from "react";
import { marked } from "marked";

function wrapTables(html: string): string {
  return html
    .replace(/<table>/g, '<div class="table-wrapper"><table>')
    .replace(/<\/table>/g, "</table></div>");
}

function stripTitlePrefix(html: string): string {
  return html.replace(/<h1([^>]*)>RADIECE (PRIVATE LIMITED|PVT LTD)\s*[—–-]\s*/g, "<h1$1>");
}

function addHeadingIds(html: string): string {
  return html.replace(/<h([1-6])>(.*?)<\/h\1>/g, (_match, level, content) => {
    const textContent = content.replace(/<[^>]+>/g, "");
    const id = textContent
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
    return `<h${level} id="${id}">${content}</h${level}>`;
  });
}

export function DocumentRenderer({ content }: { content: string }) {
  const html = useMemo(() => {
    const raw = marked.parse(content, { async: false }) as string;
    return addHeadingIds(stripTitlePrefix(wrapTables(raw)));
  }, [content]);

  return (
    <div className="prose" dangerouslySetInnerHTML={{ __html: html }} />
  );
}
